//
// Get a city base on ID from city data in nuxt
//
export function useCityById(cityId) {
  // Get config from server plugin
  const config = useNuxtApp().$configData
  const cities = config?.wa?.cities
  return cities?.find(city => city.id === cityId)
}

//
// Get a city based on slug from city data in nuxt
//
export function useCityBySlug(citySlug) {
  // Get config from server plugin
  const config = useNuxtApp().$configData
  const cities = config?.wa?.cities
  return cities?.find(city => useSlugify(city.name) === citySlug)
}

//
// Get a city name with proposition prefix
//
export function usePrefixedCityName(cityName) {
  const { t } = useI18n()
  const citySlugs = ['öland', 'gotland', 'österlen', 'käringön', 'gräddö', 'hönö', 'fårö', 'eckerö', 'ulvön', 'orust', 'klädesholmen']
  const preposition = citySlugs.some(slug => slug === cityName?.toLowerCase())
    ? t('shared.at')
    : t('shared.in')
  
  return `${preposition} ${cityName}`
}
